import type { DeprecatedButtonTokens } from '../types';

export const deprecatedButton: DeprecatedButtonTokens = {
  colors: {
    darkButtonTextColor: 'brandPrimary.2',
    lightButtonBgColor: '#FED4B3',
  },
};
